export enum DealStatus {
  NotContacted = 'Not Contacted',
  Attempted = 'Attempted',
  Contacted = 'Contacted',
  Appointment = 'Appointment',
  Negotiating = 'Negotiating',
  Sold = 'Sold',
  LostDeal = 'Lost Deal',
}
